import gql from 'graphql-tag';

export const deleteVideoMutation = gql`
  mutation DeleteVideo($id: String!) {
    deleteVideo(id: $id)
  }
`;

export const updateVideoMutation = gql`
  mutation UpdateVideo($id: String!, $videoTitle: String!) {
    updateVideo(id: $id, videoTitle: $videoTitle) {
      id
      videoTitle
    }
  }
`;

export const createVideoMutation = gql`
  mutation CreateVideo(
    $videoTitle: String!
    $published: Boolean
    $saved: Boolean
    $thumbUrl: String
    $videoUrl: String
    $videoType: VideoType!
  ) {
    createVideo(
      videoTitle: $videoTitle
      published: $published
      saved: $saved
      thumbUrl: $thumbUrl
      videoUrl: $videoUrl
      videoType: $videoType
    ) {
      video {
        id
        videoTitle
        videoUrl
        thumbUrl
        status
      }
      uploadLink
    }
  }
`;

export const addEngageVideoMutation = gql`
  mutation AddEngageVideo($videoId: String!, $documentId: String!) {
    addEngageVideo(videoId: $videoId, documentId: $documentId)
  }
`;

export const removeEngageVideoMutation = gql`
  mutation RemoveEngageVideo($documentId: String!, $videoId: String!) {
    removeEngageVideo(documentId: $documentId, videoId: $videoId)
  }
`;

export const copyVideoMutation = gql`
  mutation CopyVideo($id: String!) {
    copyVideo(id: $id) {
      id
      videoTitle
      videoUrl
      thumbUrl
      status
    }
  }
`;
